// The one entry point for game data (IMPLEMENTATION §1.4, §2.1 boot step "data/defs").
//   DEV:  shared/data/*.json → zod → compile() (data/loaderDev.ts, dynamically imported), with HMR.
//   PROD: shared/compiled/simdefs.json + the presentation JSON (data/loaderProd.ts); `import.meta.env.DEV`
//         is statically false, so the dev branch (zod, the compiler, the glob) is dropped from the bundle.
import type { GameData } from './gameData.ts';
import { compiledGameData } from './loaderProd.ts';

export type { GameData } from './gameData.ts';
export { onDataReload } from './reloadBus.ts';

export async function loadGameData(): Promise<GameData> {
  if (import.meta.env.DEV) {
    const dev = await import('./loaderDev.ts');
    return dev.loadFromSources();
  }
  return compiledGameData();
}
